export default {
    API_URL: {
        BASE:                   'https://rdv.z-app.co/api',
        GET_SERVICES:           '/service_categories',
        GET_EMPLOYEES:          '/services_employees',
        GET_AVAILABLE_TIMES:    '/agendas/available-time',
        GET_AVAILABLE_DAYS:     '/agendas/available-days',
        GET_USER_BY_PHONE:      '/clients/phone',
        VALIDATE_CODE:          '/agenda-booking/check-validation',
        SAVE_BOOKING:           '/agenda-booking',
        SAVE_USER:              '/clients',
        UPDATE_BOOKING:         '/agenda-booking',
        GET_PARAMETERS:         '/booking-parameters',
    }
};



// WEBPACK FOOTER //
// ./src/config.js